import { forwardRef } from 'react';
import MuiBadge, {
  badgeClasses,
  BadgeProps as MuiBadeProps,
} from '@mui/material/Badge';

import styled from 'shared/utils/styled';

const StyledBadge = styled(MuiBadge)(({ theme }) => ({
  [`& .${badgeClasses.anchorOriginTopRightRectangular}`]: {
    right: -15,
    fontFamily: 'NeoSansStd',
    fontSize: 11,
    background: theme.palette.error.main,
    color: '#fff',
  },
}));

const Badge = forwardRef<HTMLSpanElement, MuiBadeProps>(function Badge(
  props,
  ref
) {
  const { children, max = 9, ...rest } = props;

  return (
    <StyledBadge ref={ref} max={max} {...rest}>
      {children}
    </StyledBadge>
  );
});

export default Badge;
